// extracted by mini-css-extract-plugin
export default {"contentView":"Layout_contentView__nLxrK","minimalContentView":"Layout_minimalContentView__rc1-u"};